import { RouteObject } from "react-router-dom";

export default [
    {
        index: true,
        lazy: async () => {
            const { default: CustomerRewards } = await import("modules/rewards/pages/CustomerRewards");
            return { Component: CustomerRewards };
        },
    },
] as RouteObject[];
